import React, { FC, useRef, useCallback, MouseEvent } from "react"
import { ClickAwayListener, Popper, OutlinedButton, Panel } from "dash-styled"
import { ReactComponent as CommandIcon } from "icons/lib/command.svg"
import { useBoolean } from "../../../../../../../Hooks/useBoolean"
import type { KeyboardShortcut } from "resha"
import { AnnotationShortcutListItem } from "../../../../../../Common/Lazy/AnnotationShortcutListItem"

interface ShortcutViewProps {
    shortcutList?: { [key: string]: [string, KeyboardShortcut][] }
}

export const ShortcutView: FC<ShortcutViewProps> = ({ shortcutList }) => {
    const [isOpen, , close, toggle] = useBoolean(false)
    const anchorEl = useRef<HTMLButtonElement>(null)

    const handleClickAway = useCallback(
        (e: MouseEvent<Document>) => {
            if (
                e.target instanceof Node &&
                anchorEl.current !== null &&
                !anchorEl.current.contains(e.target)
            ) {
                close()
            }
        },
        [close]
    )

    return (
        <>
            <OutlinedButton
                ref={anchorEl}
                Icon={CommandIcon}
                marginRight="2"
                label="Shortcuts"
                onClick={toggle}
            />
            <ClickAwayListener onClickAway={handleClickAway}>
                <Popper
                    open={isOpen}
                    anchorEl={anchorEl.current}
                    transition={true}
                    className="pt-2 pb-1 cursor-auto"
                    disablePortal={true}
                    placement="bottom-start"
                >
                    <Panel
                        className="p-1 min-w-48 rounded-lg border border-rhino-300 flex divide-x divide-smoke-20"
                        noPadding={true}
                        noRadius={true}
                    >
                        {shortcutList
                            ? Object.entries(shortcutList).map(
                                  ([shortcutTitle, shortcuts]) => (
                                      <section
                                          key={shortcutTitle}
                                          className="px-8 py-3 flex-1 min-w-detail-page-tile"
                                      >
                                          <h5 className="font-semibold text-sm">
                                              {shortcutTitle}
                                          </h5>
                                          <ul className="list-none p-0 m-0 space-y-3">
                                              {shortcuts.map(
                                                  ([
                                                      key,
                                                      shortcutInCategory
                                                  ]) => (
                                                      <AnnotationShortcutListItem
                                                          key={key}
                                                          shortcut={
                                                              shortcutInCategory
                                                          }
                                                          active={true}
                                                      />
                                                  )
                                              )}
                                          </ul>
                                      </section>
                                  )
                              )
                            : null}
                    </Panel>
                </Popper>
            </ClickAwayListener>
        </>
    )
}
